import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { DeleteBoxInput, DeleteBoxOutput } from "types/web-app";

export const deleteBox = async (accessToken: string, input: DeleteBoxInput) => {
  try {
    const response = await fetchWithAuth("/box/delete", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<DeleteBoxOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
